import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Cod promoțional {{code}} aplicat',
  [COUPON_TYPES.CASHBACK]: 'Puncte de fidelitate aplicate',
  [COUPON_TYPES.REWARD]: 'Recompensă aplicată',
  [COUPON_TYPES.GIFT_CARD]: 'Card cadou aplicat',
};

export default Coupons;
